import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { FileText } from "lucide-react";
import { toast } from "sonner";

export default function PdfTemplates() {
  const { t } = useI18n();
  const [tpls, setTpls] = useState([]);
  useEffect(() => { api.get("/registry/pdf-templates").then((r) => setTpls(r.data.templates)).catch((e) => toast.error(apiErr(e.response?.data?.detail))); }, []);
  return (
    <div data-testid="pdf-templates">
      <div className="flex items-center gap-3 mb-4"><FileText className="h-6 w-6 text-primary" /><h1 className="text-2xl font-display font-bold text-slate-900">{t("pdfTemplates")}</h1></div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {tpls.map((tp) => (
          <Card key={tp.code} className="border-slate-200 p-4" data-testid={`template-${tp.code}`}>
            <div className="flex items-center justify-between mb-1">
              <span className="font-semibold text-slate-800">{tp.name}</span>
              <Badge className={`border-0 text-xs ${tp.active ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>{tp.active ? t("active") : "SPECIMEN"}</Badge>
            </div>
            <p className="text-xs text-slate-500 mb-2">{tp.description}</p>
            <div className="text-[11px] text-slate-400">v{tp.version} · {tp.logo}</div>
            {tp.variables?.length > 0 && <div className="mt-2 flex flex-wrap gap-1">{tp.variables.map((v) => <Badge key={v} className="bg-slate-100 text-slate-500 border-0 text-[10px]">{v}</Badge>)}</div>}
          </Card>
        ))}
      </div>
    </div>
  );
}
